<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Purchases</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <div class="p-4 px-6">
    <div class="table-navigator">
      <ion-segment mode="ios" [(ngModel)]="statusSegment" (ionChange)="onStatusSegmentChange()">
        <ion-segment-button value="all">All</ion-segment-button>
        <ion-segment-button value="active">Active</ion-segment-button>
        <ion-segment-button value="expired">Expired</ion-segment-button>
        <ion-segment-button value="deactivated">Deactivated</ion-segment-button>
      </ion-segment>
      <pagination-box [paginatedResponse]="paginatedPurchases"
        (changePage)="fetchPlanPurchase($event)"></pagination-box>
    </div>
  </div>

  <div class="px-8">
    <div [ngClass]="gridClass" class="pt-4 pb-6 mb-[-8px] px-4 bg-ocean-300 rounded-t-md text-sm font-medium">
      <p class="m-0 min-w-0">Organisation</p>
      <p class="m-0 min-w-0">Plan</p>
      <p class="m-0 min-w-0">Activated</p>
      <p class="m-0 min-w-0">Expires</p>
      <p class="m-0 min-w-0">Duration</p>
      <p class="m-0 min-w-0">Status</p>
      <p class="m-0 min-w-0 text-right">Amount</p>
    </div>
  </div>

  <div class="px-6 pb-6">
    <div class="flex flex-col bg-white overflow-hidden rounded-md shadow-sm border border-gray-200">
      @if (isLoading) {
      @for (item of [1, 2, 3, 4, 5]; track item) {
      <div [ngClass]="gridClass" class="p-4 px-4 border-b border-gray-200 last:border-b-0">
        @for (cell of skeletonCells; track cell) {
        <ion-skeleton-text class="block h-3.5 w-full rounded" [animated]="true"></ion-skeleton-text>
        }
      </div>
      }
      } @else {
      @for (purchase of paginatedPurchases.docs; track purchase._id) {
      <div [ngClass]="gridClass"
        class="p-4 px-4 border-b border-gray-200 last:border-b-0 hover:bg-gray-50 cursor-pointer"
        (click)="openPurchase(purchase)">
        <p class="m-0 text-sm font-medium truncate min-w-0">{{ purchase.organisation?.name || '—' }}</p>
        <p class="m-0 text-sm truncate min-w-0">{{ purchase.plan?.name || 'No plan' }}</p>
        <p class="m-0 text-sm">{{ purchase.activationTime ? (purchase.activationTime | date : 'dd MMM yyyy') : '—' }}
        </p>
        <p class="m-0 text-sm">{{ purchase.expireTime ? (purchase.expireTime | date : 'dd MMM yyyy') : '—' }}</p>
        <p class="m-0 text-sm">
          @if (purchase.planPricingModel?.validityDays) {
          {{ purchase.planPricingModel.validityDays }} days
          } @else {
          —
          }
        </p>
        <span class="inline-block w-fit px-2.5 py-0.5 rounded-full text-[11px] font-semibold whitespace-nowrap"
          [ngClass]="statusClass(purchase)">
          {{ statusLabel(purchase) }}
        </span>
        <p class="m-0 text-sm text-right tabular-nums">
          @if (purchase.priceBreakup?.payableAmount != null) {
          ₹{{ purchase.priceBreakup.payableAmount | number : '1.0-2' }}
          } @else {
          —
          }
        </p>
      </div>
      }

      @if (paginatedPurchases.docs.length === 0) {
      <div class="p-12 text-center text-gray-500">
        <p class="m-0">No purchases found for the selected filters.</p>
      </div>
      }
      }
    </div>
  </div>

  @if (paginatedPurchases.docs.length > 0) {
  <div class="w-full flex flex-row justify-end p-6 pb-10">
    <pagination-box [paginatedResponse]="paginatedPurchases" (changePage)="fetchPlanPurchase($event)"></pagination-box>
  </div>
  }

</ion-content>